import React from 'react'
import { View } from 'oio-react'
import { ColorPaletteGlyph24Icon, SiteNavigationIcon, TypographyGlyph24Icon } from 'assets/icons'
import ProtoColumnNavButton from 'src/components/Settings/ProtoColumnNavButton'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import { settingsUrl, settingsDesignUrl } from 'src/components/utils/urls'

const SettingsDesignHome = () => (
   <View>
      <ProtoReturnBar
         display="block[a-b] none[c-f]"
         returnLinkName="Admin Workspace"
         returnLinkTo={settingsUrl}
      />
      <View>
         <View
            display="flex"
            justifyContent="center"
            width="100%">
            <View width="100%" maxWidth="90%[c] 480px[d]">
               <View
                  float="left"
                  display="flex"
                  padding="40px 20px[a-b] 40px 0px[c-d] 40px 20px[e-f]">
                  <ProtoHeadingBlock
                     colorMode="light"
                     title="Design & Layout"
                     description="Customize the overall appearance, look and feel of your Site."
                  />
               </View>
               <View float="left" width="100%" paddingBottom="90px">
                  <View
                     backgroundColor="#fafafa"
                     padding="10px 0px[c-d]"
                     borderRadius="5px[c-d]"
                     borderTop="1px solid rgba(0,0,0,0.05)[a-b] 1px solid rgba(0,0,0,0.05)[e-f]"
                     borderBottom="1px solid rgba(0,0,0,0.05)[a-b] 1px solid rgba(0,0,0,0.05)[e-f]">
                     <ProtoColumnNavButton
                        borderStyle="none"
                        linkName="Main Menu"
                        linkTo={`${settingsDesignUrl}/main-menu`}
                        icon={(
                           <SiteNavigationIcon
                              className="icon"
                              width="15px"
                              height="15px"
                           />
                        )}
                     />
                     <ProtoColumnNavButton
                        linkName="Color Palette"
                        linkTo={`${settingsDesignUrl}/colors`}
                        icon={(
                           <ColorPaletteGlyph24Icon
                              className="icon"
                              width="16px"
                              height="16px"
                           />
                        )}
                     />
                     <ProtoColumnNavButton
                        linkName="Typography"
                        linkTo={`${settingsDesignUrl}/typography`}
                        icon={(
                           <TypographyGlyph24Icon
                              className="icon"
                              width="16px"
                              height="16px"
                           />
                        )}
                     />
                  </View>
               </View>
            </View>
         </View>
      </View>
   </View>
)

export default SettingsDesignHome
